<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div class="col-md-12 mb-5">
        <div class="row">
            <div class="formdynamic_item col-md-2 py-0">
                <div class="formdynamic__item__field mt-4">
                    <label v-html="`Sort by number of rooms completed`" class="modal-label ml-2"/>
                    <span class="custom-control custom-checkbox">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="sort_out_by_rooms_completed"
                            v-model="form_data.sort_out_by_rooms_completed"
                        />
                        <label class="custom-control-label ml-2" for="sort_out_by_rooms_completed">
                        </label>
                    </span>
                </div>
            </div>
            <div class="formdynamic_item col-md-2 py-o">
                <div class="formdynamic__item__field">
                    <label class="modal-label input-date-template" v-html="`Date Range:`"/>
                    <date-range-picker
                    class="d-block"
                    ref="picker"
                    v-model="form_data.date_range"
                    cancelLabel="Clear">
                        <template v-slot:input="picker" style="min-width: 350px;">
                            {{ date(picker.startDate) }} - {{ date(picker.endDate) }}
                        </template>

                        <div slot="footer" slot-scope="data" class="slot p-2">
                            <span class="d-inline-block" style="margin-left: 2px; font-size: 13px; min-width: 7.5rem;">
                            {{ data.rangeText }}
                            </span>
                            <span style="margin-left: auto">
                                <a @click="clearRangeDate(data)" class="modal__buttons__item cancel">Cancel</a>
                            </span>
                            <span style="margin-left: auto">
                                <a @click="data.clickApply" v-if="!data.in_selection" class="modal__buttons__item" style="width: 4.5rem">Apply</a>
                            </span>
                        </div>
                    </date-range-picker>
                </div>
            </div>
        </div>
        <div class="formdynamic_item col-md-4 py-o">
            <button  class="modal__buttons__item w-auto px-3 ml-0" @click="getReport()">View Report</button>
        </div>
    </div>
    <GChart
        v-show="true"
        ref="chart"
        class="mt-2 gchart-custom-invisible"
        type="BarChart"
        :data="data"
        :options="chartOptions"
        :width="'100%'"
        :height="chartHeight"
        @ready="onChartReady"
        style="display: none;"
    />
    <div class="tab-content" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-lg-10" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>

  
  
<script>
import axios from 'axios';
import Resources from './resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
const notyf = new Notyf({
    duration: 8000,
});
import { GChart } from 'vue-google-charts/legacy'

export default {

    name: "RoomTypeByBuildingReport",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        DateRangePicker,
        GChart
    },

    data() {
        return {
            notyf,
            axios,
            parent_id: 34,
            staffing_scenario_id: this.$route.params.id,
            user: this.get_user(),
            title_page: 'Reports',
            rest_api: `search_standard_reports`,
            title: 'Graph - Number of Rooms Inspected Grouped by Template',
            current_url: `/reports`,
            table_headers: [],
            breadcrumb: JSON.parse(JSON.stringify(Resources.breadcrumb)),
            search: '',
            first_request: true,
            pdfSource: '',
            form_data:  {date_range: {startDate: "", endDate: ""}, sort_out_by_rooms_completed: true},
            data: [],
            chart_image_uri: '',
            moment
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        clearRangeDate(data)
        {
            data.clickCancel()
            this.form_data.date_range = { startDate: null, endDate: null }
        },

        date(val) 
        {
            return val ? moment(val).format("MM/D/YYYY") : "";
        },

        onChartReady(chart, google) {
            let that = this;
            google.visualization.events.addListener(chart, 'ready', function () {
                const svgElement = chart.container.querySelector('svg') || chart.getChartLayoutInterface?.().getContainer()?.querySelector('svg');
                
                if (svgElement) {
                    // Serialize SVG XML
                    const svgData = new XMLSerializer().serializeToString(svgElement);
                    const svgBlob = new Blob([svgData], {type: 'image/svg+xml;charset=utf-8'});
                    const url = URL.createObjectURL(svgBlob);

                    // Create image and canvas for higher resolution rendering
                    const img = new window.Image();
                    img.onload = function() {
                        // Set desired canvas size for higher quality (2x size)
                        const width = svgElement.width ? parseInt(svgElement.width.baseVal.value) : svgElement.clientWidth || 600;
                        const height = svgElement.height ? parseInt(svgElement.height.baseVal.value) : svgElement.clientHeight || 380;

                        const scale = 2; // adjust for quality
                        const canvas = document.createElement('canvas');
                        canvas.width = width * scale;
                        canvas.height = height * scale;
                        canvas.style.width = width + 'px';
                        canvas.style.height = height + 'px';

                        const ctx = canvas.getContext('2d');
                        ctx.setTransform(scale, 0, 0, scale, 0, 0);
                        ctx.drawImage(img, 0, 0);

                        // Set high-res PNG data URI
                        that.chart_image_uri = canvas.toDataURL('image/png');
                        URL.revokeObjectURL(url);
                    };
                    img.onerror = function() {
                        // fallback to default, if render failed
                        that.chart_image_uri = chart.getImageURI();
                        URL.revokeObjectURL(url);
                    };
                    img.src = url;
                } else {
                    // fallback if SVG unavailable
                    that.chart_image_uri = chart.getImageURI();
                }
            });
        },


        async getReport(print_report = false)
        {
            if(this.form_data.date_range.startDate === null || this.form_data.date_range.endDate === null)
            {
                this.notyf.error('Please select a date range')
                return
            }

            const form_data = {
                standard_report_id: 34,
                params: {...this.form_data, chart_image_uri: this.chart_image_uri, print_report}
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if (response.status) 
            {
                if(!print_report)
                {
                    this.data = response.data.map(row => {
                        return [row[0], row[1], row[1]];
                    });

                    if(this.data.length > 0)
                    {
                        this.data.unshift(['Inspection Template', 'Rooms', { role: 'annotation' }]);
                        setTimeout(() => {
                            this.getReport(true)
                        }, 200);
                    }
                    else
                    {
                        this.notyf.error('No records found for the selected date range')
                        this.pdfSource=  ''
                    }
                }
                else
                {
                    const base64Data = await this.downloadFile(response, true)
                    var blobUrl = URL.createObjectURL(base64Data); 
                    this.pdfSource= blobUrl
                }
            } 
            else 
            {
                this.error_handling(response)
            }

            this.loader(false)
        },

    },

    computed: {
        chartHeight() {
            // Calculate height based on number of bars
            // Each bar needs enough space for the annotation text (font-size 14)
            const barCount = this.data.length > 0 ? this.data.length - 1 : 0; // Subtract header row
            const baseHeight = 120; // Space for legend, axes, padding
            // Use 40px per bar to accommodate 14px font annotations consistently
            const barHeight = 40; // Height per bar
            return Math.max(380, baseHeight + (barCount * barHeight)); // Minimum 380px
        },
        
        chartOptions() {
            // Calculate chartArea height to minimize blank space
            const barCount = this.data.length > 0 ? this.data.length - 1 : 0;
            let chartAreaHeight = '70%';
            
            if (barCount > 0) {
                // Reserve fixed space for legend and axes (about 100px)
                const totalHeight = this.chartHeight;
                const marginSpace = 100; // pixels for legend, axes, labels
                const chartAreaHeightPercent = ((totalHeight - marginSpace) / totalHeight) * 100;
                chartAreaHeight = `${Math.min(92, Math.max(70, chartAreaHeightPercent))}%`;
            }
            
            return {
                legend: { 'position': 'bottom' },
                chartArea: { 
                    'width': '50%', 
                    height: chartAreaHeight,
                    top: 40, // Fixed top padding
                },
                height: this.chartHeight,
                hAxis: {
                    format: '0',
                },
                bar: { groupWidth: "75%" },
                annotations: {
                    alwaysOutside: false,
                    textStyle: {
                        fontSize: 18,
                        bold: true,
                        color: '#000',
                    },
                },
                // Prevent text scaling
                vAxis: {
                    textStyle: {
                        fontSize: 18
                    }
                },
                // Force consistent text rendering
                forceIFrame: false,
                enableInteractivity: true
            };
        }
    },

    watch: {
    },

    async mounted() 
    {
        if (this.hasPermissions(['Report Read'])) 
        {
            const today = moment();
            const startDate = today.clone().day(0).format('YYYY-MM-DD') + "T23:00:00.000Z";
            const endDate = today.clone().day(6).format('YYYY-MM-DD') + "T23:59:59.999Z";

            this.form_data.date_range = {startDate: startDate, endDate: endDate}

            this.breadcrumb.push(
                {
                    name: 'Graph - Number of Rooms Inspected Grouped by Template',
                    href: 'inspection-template-completion-by-room',
                    arrow: '',
                },
            )
        }
    },

}
</script>
<style>
.gchart-custom-invisible {
    left: -9999px;
    width: 100vw;
    position: absolute;
}
</style>
